<script>
export default {
  props: ['stableData']
}
</script>

<template>
  <div class="pg">
    <!--      功率因数-->
    <div class="dataItems">
      <div class="title">功率因数</div>
      <div class="dataItem">
        <div class="dataName">
          <div class="dataTitle"></div>
          <div class="dataNvItem" style="display: flex; flex-direction: column; min-width: 100px">
            <div>全波功率因数</div>
            <div>PF</div>
          </div>
          <div class="dataNvItem" style="display: flex; flex-direction: column; min-width: 100px">
            <div>基波功率因数</div>
            <div>DPF</div>
          </div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">A相</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.pf_pha : 0).toFixed(3) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.dpf_pha : 0).toFixed(3) }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">B相</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.pf_phb : 0).toFixed(3) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.dpf_phb : 0).toFixed(3) }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">C相</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.pf_phc : 0).toFixed(3) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.dpf_phc : 0).toFixed(3) }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">AVE</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.pf_total : 0).toFixed(3) }}</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.dpf_total : 0).toFixed(3) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.dataValue {
  width: 20%;
}

.dataNvItem {
  margin: 20px 0;
  height: calc((100% - 70px) / 4);
}
</style>



// WEBPACK FOOTER //
// src/pages/Stable/PFactor/PFactor.vue